/**
 * @file
 * Custom JS behaviour for History.
 */

(function ($) {

  Drupal.behaviors.responsive_menu = {
    attach: function (context, settings) {

      var $body = $('body');

      if (!$body.hasClass('responsive-menu')) {

        once('initialized', '#block-navigazioneprincipale', context).forEach((el) => {

          var $navigationMainRegion = $('.region-navigation-main');
          const $menuMobile = document.querySelector('#block-navigazioneprincipale');
          const $menuProducts = document.querySelector('ul.menu-products');

          // Add internal wrapper to main menu.
          $menuMobile.querySelectorAll('li.menu-item ul.menu').forEach((item, index) => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('item-list');
            item.before(wrapper);
            // add the element to the wrapper
            wrapper.appendChild(item);
            // Add back markup for submenu.
            /*const divBack = document.createElement('div');
            divBack.classList.add('menu-back');
            wrapper.prepend(divBack);*/
          });

          // Move products links.
          document.querySelectorAll('#block-aromitaliamenumobile li.menu-level-1').forEach((item, index) => {
            document.querySelector('#block-navigazioneprincipale > ul').appendChild(item);
          });

          // Add class item-special.
          /*document.querySelectorAll('#block-navigazioneprincipale > ul > li:last-child li:first-child').forEach((item, index) => {
            item.classList.add('item-special');
          });*/

          // Burger and close menu - markup and behaviour.
          $navigationMainRegion.append('<div id="menu-close"></div>');

          var $menuBurger = $('#burger-menu');
          var $menuClose = $('#menu-close');

          $menuBurger.click(function (e) {
            $body.addClass('h-noscroll');
            $navigationMainRegion.addClass('open');
          });

          $menuClose.click(function (e) {
            $navigationMainRegion.removeClass('open');
            $body.removeClass('h-noscroll');
          });

          // Add back markup for submenu
          $menuMobile.querySelectorAll('.item-list').forEach((item, index) => {
            const divBack = document.createElement('div');
            divBack.classList.add('menu-back');
            item.prepend(divBack);
          });

          // Duplicate internal submenus titles
          document.querySelectorAll('#block-navigazioneprincipale .menu-item--expanded:not(.menu-level-1)').forEach((item, index) => {
            if (item.querySelector('ul')) {
              const $link = item.children.item(0);
              const text = $link.innerText;
              const span = document.createElement('span');
              span.innerHTML = text;
              $link.before(span);
              $link.remove();
            }
          });


          // Open submenu.
          $('#block-navigazioneprincipale .menu-item--expanded span').click(function (e) {
            e.preventDefault();
            var $itemList = $(this).siblings('.item-list');
            $itemList.addClass('open');
          });

          $('.menu-back').click(function (e) {
            e.preventDefault;
            var $parent = $(this).parent();
            $parent.each(function () {
              $(this).removeClass('open');
            });
          });

          $body.addClass('responsive-menu');

        });
      }

    },

  };

})(jQuery);
